export default __webpack_public_path__ + "static/media/plain-sticker-el.cc8ef053.png";